import { Navigate, useParams } from "react-router-dom";
import { useUser } from "../../auth";
import { WorkflowEditor } from "../../components/WorkflowEditor/WorkflowEditor";
import "../../components/WorkflowEditor/styles.css";
import { ROUTES } from "..";

/**
 * Host route for the workflow definition editor.
 *
 * The editor's own stylesheet is imported here rather than by the component, so it is loaded once
 * by whatever renders it. Every rule in it is namespaced under ``aer-wf`` — see styles.css.
 */
export function AdminWorkflowEditorPage() {
    const isSuperuser = useUser().isSuperuser;
    const { definitionId } = useParams<{ definitionId: string }>();

    // Matches IsAdminSuperUser on the API — see the note in AdminWorkflowsPage.
    if (!isSuperuser) {
        return <Navigate to={ROUTES.ROOT} />;
    }

    if (!definitionId) {
        return <Navigate to={ROUTES.ADMIN_WORKFLOWS} />;
    }

    return (
        <div className="container mx-auto px-6 pt-6">
            <WorkflowEditor definitionId={definitionId} />
        </div>
    );
}
